export { default as BaseException } from './BaseException';
